enum BaseURLConfig {
  PALMETTO = 'PALMETTO',
  DMA = 'DMA',
  DOCUMENT = 'DOCUMENT',
  NULL = 'NULL',
}

export default BaseURLConfig;
